module.exports = __webpack_public_path__ + "img/swipe3-icon.34637a5b.png";